module.exports = __webpack_public_path__ + "static/media/taco-2.baf2f6cf.jpg";